export { default } from "./ExpoScreenshot";
